"use client";

import { MapWithList } from "@/components/map-with-list";
import { Badge } from "@myapp/ui/badge";

export default function TestMapListPage() {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="max-w-7xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">
            지역별 특산물 동적 연동 테스트
          </h1>
          <p className="text-muted-foreground">
            지도에서 지역을 선택하여 특산물 리스트가 동적으로 로드되는지 확인해보세요.
          </p>
          <div className="flex justify-center gap-2">
            <Badge variant="outline">디바운스 150ms</Badge>
            <Badge variant="outline">커서 기반 페이지네이션</Badge>
            <Badge variant="outline">조회수 내림차순</Badge>
          </div>
        </div>

        {/* 메인 컴포넌트 */}
        <MapWithList showFavorite={true} />

        {/* 기능 설명 */}
        <div className="space-y-6 bg-card border rounded-lg p-6">
          <h2 className="text-xl font-semibold">구현된 기능</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-3">
              <h3 className="font-semibold text-primary">지도 상호작용</h3>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li>• 지역 클릭 시 URL 쿼리 파라미터 업데이트</li>
                <li>• 150ms 디바운스로 불필요한 API 호출 방지</li>
                <li>• 새로고침/공유 시 선택 상태 복원</li>
                <li>• 시각적 피드백 및 선택된 지역 표시</li>
              </ul>
            </div>
            
            <div className="space-y-3">
              <h3 className="font-semibold text-primary">특산물 리스트</h3>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li>• 지역별 필터링 및 조회수 내림차순 정렬</li>
                <li>• 커서 기반 페이지네이션 (12개씩)</li>
                <li>• 로딩 상태 및 에러 처리</li>
                <li>• 빈 상태 및 '더 보기' 기능</li>
              </ul>
            </div>
            
            <div className="space-y-3">
              <h3 className="font-semibold text-primary">API 설계</h3>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li>• RESTful API with query parameters</li>
                <li>• Mock 데이터로 개발 진행</li>
                <li>• Prisma 연동 준비 완료 (주석 처리)</li>
                <li>• 에러 처리 및 응답 구조 표준화</li>
              </ul>
            </div>
            
            <div className="space-y-3">
              <h3 className="font-semibold text-primary">사용자 경험</h3>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li>• 직관적인 지역 선택 인터페이스</li>
                <li>• 실시간 데이터 업데이트</li>
                <li>• 반응형 레이아웃 지원</li>
                <li>• 접근성 및 키보드 내비게이션</li>
              </ul>
            </div>
          </div>

          <div className="p-4 bg-muted rounded-lg">
            <h4 className="font-semibold mb-2">테스트 시나리오</h4>
            <ol className="space-y-1 text-sm">
              <li>1. 춘천시를 클릭하여 춘천 특산물 확인</li>
              <li>2. 횡성군을 클릭하여 한우 등심 확인</li>
              <li>3. 속초시를 클릭하여 오징어 확인</li>
              <li>4. '더 보기' 버튼으로 페이지네이션 테스트</li>
              <li>5. URL 공유로 상태 복원 테스트</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}